module.exports = __webpack_public_path__ + "img/05 - Condominio_das_Americas_Academia.b5c0829b.jpg";